import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=046d75ec&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&id=046d75ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d75ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046d75ec')) {
      api.createRecord('046d75ec', component.options)
    } else {
      api.reload('046d75ec', component.options)
    }
    module.hot.accept("./channel.vue?vue&type=template&id=046d75ec&scoped=true&", function () {
      api.rerender('046d75ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/channel.vue"
export default component.exports